export default __webpack_public_path__ + "static/BM-1-ce97b86dc843b44b2af86236b6574c89.png";